import React, { createContext, useContext } from 'react';
import { toast as sonnerToast } from 'sonner';

const ToastContext = createContext();

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};

export const ToastProvider = ({ children }) => {
  const showToast = (message, options = {}) => {
    return sonnerToast(message, options);
  };

  const showSuccess = (message, options = {}) => {
    return sonnerToast.success(message, options);
  };

  const showError = (message, options = {}) => {
    return sonnerToast.error(message, options);
  };

  const showWarning = (message, options = {}) => {
    return sonnerToast.warning(message, options);
  };

  const showInfo = (message, options = {}) => {
    return sonnerToast.info(message, options);
  };

  const showLoading = (message, options = {}) => {
    return sonnerToast.loading(message, options);
  };

  const dismiss = (toastId) => {
    sonnerToast.dismiss(toastId);
  };

  const dismissAll = () => {
    sonnerToast.dismiss();
  };

  const value = {
    showToast,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    showLoading,
    dismiss,
    dismissAll,
  };

  return (
    <ToastContext.Provider value={value}>
      {children}
    </ToastContext.Provider>
  );
};
